import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import "./legal.scss";

export default function TermsPage() {
  return (
    <div id="legal-page">
      <div className="legal-bg" aria-hidden="true" style={{ "--legal-bg-image": 'url("/landing/bobspace.webp")' }} />
      <Nav useSmoothScroll={false} />

      <main className="legal-main">
        <section className="legal-card">
          <p className="legal-kicker">Legal</p>
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: May 8, 2026</p>

          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using Bob Monad websites, dashboards, and related services, you agree to these Terms of Service.
            If you do not agree, do not use the services.
          </p>

          <h2>2. No Financial Advice</h2>
          <p>
            Content on this site is for informational and community purposes only and is not financial, legal, or tax advice.
            You are solely responsible for your decisions and wallet activity.
          </p>

          <h2>3. Wallet and Account Responsibility</h2>
          <p>
            You are responsible for maintaining the security of your wallet, private keys, and connected accounts.
            Bob Monad cannot recover lost keys, funds, or compromised accounts.
          </p>

          <h2>4. Eligibility and Conduct</h2>
          <p>
            You agree to use the services lawfully and not engage in abuse, automation attacks, fraudulent task claims, or attempts
            to exploit reward systems.
          </p>

          <h2>5. Third-Party Services</h2>
          <p>
            The website may integrate third-party platforms and tools (for example wallets, social APIs, bridges, and exchanges).
            Your use of those services is subject to their own terms and policies.
          </p>

          <h2>6. Service Availability</h2>
          <p>
            Services are provided on an “as is” and “as available” basis. Features may change, pause, or be removed at any time
            without notice.
          </p>

          <h2>7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Bob Monad and contributors are not liable for indirect, incidental, or consequential
            damages arising from use of the services.
          </p>

          <h2>8. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Continued use after updates means you accept the revised Terms.
          </p>

          <h2>9. Contact</h2>
          <p>
            For questions, contact the team via the official Bob Monad community channels listed on the website.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
}

